import * as React from "react";
import { canUseDOM } from "./utils";
export function useUsersManagementState(initialState) {
    const [[state, effects], dispatch] = React.useReducer(reducer, [
        initialState,
        [],
    ]);
    React.useEffect(() => {
        if (window !== window.top) {
            // do not use query params if widget is rendered in an iframe
            return;
        }
        const params = new URLSearchParams(window.location.search);
        dispatch({ type: "INIT", params });
    }, []);
    React.useEffect(() => {
        for (const effect of effects) {
            effect();
        }
    }, [effects]);
    return [state, dispatch];
}
function reducer(current, action) {
    const effects = [];
    const exec = (fn) => {
        const effect = () => {
            if (!effect.disposed) {
                effect.disposed = true;
                fn();
            }
        };
        effect.disposed = false;
        effects.push(effect);
    };
    const [currentState] = current;
    switch (action.type) {
        case "INIT": {
            const { params } = action;
            let role, searchQuery;
            if ((role = params.get("ak_role"))) {
                return [{ ...currentState, searchQuery: null, role }, effects];
            }
            if ((searchQuery = params.get("ak_q"))) {
                return [{ ...currentState, searchQuery, role: null }, effects];
            }
            return current;
        }
        case "SET_PAGINATION": {
            const { pagination } = action;
            if ((pagination.after &&
                pagination.after === currentState.pagination?.after) ||
                (pagination.before &&
                    pagination.before === currentState.pagination?.before)) {
                return current;
            }
            return [{ ...currentState, pagination }, effects];
        }
        case "FILTER_BY_ROLE": {
            if (action.role === currentState.role) {
                return current;
            }
            const { role } = action;
            exec(() => updateQueryParams({ ak_role: role, ak_q: null }, { replaceState: true }));
            return [
                { ...currentState, pagination: null, role, searchQuery: null },
                effects,
            ];
        }
        case "FILTER_BY_SEARCH": {
            if (action.searchQuery === currentState.searchQuery) {
                return current;
            }
            const { searchQuery } = action;
            exec(() => updateQueryParams({ ak_role: null, ak_q: searchQuery }, { replaceState: true }));
            return [
                { ...currentState, pagination: null, role: null, searchQuery },
                effects,
            ];
            //
            break;
        }
        default:
            return current;
    }
}
function updateQueryParams(newParams, args = {}) {
    if (!canUseDOM) {
        throw new Error("Cannot update query params on the server");
    }
    if (window !== window.top) {
        // do not update query params if widget is rendered in an iframe
        return;
    }
    const initialSearch = window.location.search;
    const params = new URLSearchParams(initialSearch);
    Object.entries(newParams).forEach(([key, value]) => {
        if (value != null && value !== "") {
            params.set(key, String(value));
        }
        else {
            params.delete(key);
        }
    });
    if (initialSearch === `?${params.toString()}`) {
        return;
    }
    const newUrl = params.toString()
        ? `${window.location.pathname}?${params}`
        : window.location.pathname;
    if (args.replaceState) {
        window.history.replaceState({}, "", newUrl);
    }
    else {
        window.history.pushState({}, "", newUrl);
    }
}
//# sourceMappingURL=users-management-state.js.map